import { Box, Button, Stack, Typography, styled } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { text, primary, black } from "@/theme/colors";
import { typography } from "@/theme/typography";
import { rounded, spacing } from "@/theme/variables";

const DisabledButton = styled(Button)({
  minHeight: 44,
  borderRadius: rounded.sm,
  paddingLeft: spacing.sm,
  paddingRight: spacing.sm,
  backgroundColor: black[99],
  textTransform: "none",
  ...typography.body14,
  fontWeight: 500,
  "&.Mui-disabled": {
    backgroundColor: black[99],
    color: black[90],
  },
});

export const OverviewNoQuestionContainer: FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <Stack alignItems="center" justifyContent="center" gap={spacing.smd} py={spacing.xs}>
        <Box display="inline-flex" px={spacing.xs} py={spacing.xxs} bgcolor={primary[900]} borderRadius={999}>
          <Typography variant="body14Bold" color={primary[500]}>
            COMING　SOON
          </Typography>
        </Box>
        <Typography variant="body14Bold" color={text.primary} textAlign="center">
          {t("mockExam.empty.title")}
        </Typography>
      </Stack>

      <DisabledButton disabled variant="contained">
        {t("mockExam.empty.buttonText")}
      </DisabledButton>
    </>
  );
};
